var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7518",
    "data-name": "Grupo 7518",
    transform: "translate(-36 -174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2924",
    "data-name": "Rect\\xE1ngulo 2924",
    width: 18,
    height: 18,
    transform: "translate(36 174)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_109",
    "data-name": "Uni\\xF3n 109",
    d: "M21852.748,8038a2.749,2.749,0,1,1,2.75,2.749A2.754,2.754,0,0,1,21852.748,8038Zm1.5,0a1.251,1.251,0,1,0,1.252-1.251A1.251,1.251,0,0,0,21854.246,8038Zm-10,0v-.006H21843V8030a2.007,2.007,0,0,1,2-2h9v2.228h2.967l.227.3,2.824,3.593v3.9h-1.766v-.017a2.752,2.752,0,0,0-5.5,0h-3V8038a2.751,2.751,0,0,1-5.5,0Zm1.5,0a1.248,1.248,0,1,0,1.246-1.251A1.25,1.25,0,0,0,21845.748,8038Zm4-.084a.4.4,0,0,0,0-.048A.4.4,0,0,1,21849.746,8037.916Zm0-.074a2.735,2.735,0,0,0-.236-.963A2.7,2.7,0,0,1,21849.744,8037.842Zm-.24-.974c-.008-.015-.014-.03-.021-.045A.477.477,0,0,0,21849.5,8036.868Zm-.045-.091-.012-.026Zm-.053-.1a.045.045,0,0,1-.008-.013A.045.045,0,0,0,21849.406,8036.674Zm3.09-.178V8029.5H21845a.5.5,0,0,0-.5.5v6.5h.2a2.75,2.75,0,0,1,4.6,0Zm1.5-2.5h4.027l-1.789-2.266H21854Z",
    transform: "translate(-21806.5 -7850.998)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTruck);
export default __webpack_public_path__ + "static/media/ic_truck.f2ba68c65ef7ebacdd7302aa29d422c3.svg";
export { ForwardRef as ReactComponent };